import React from 'react';
import { Flag, CircleCheck, TriangleAlert, CircleX, DollarSign } from 'lucide-react';
import { StatCard, MetricRow } from '../../common';
import { formatNumber, formatCurrency } from '../../../utils/format';
import { useCampaignStats } from './campaignElements.controller';

export default function CampaignAnalytics({ campaigns }) {
    const analytics = useCampaignStats(campaigns);

    return (
        <div className="grid gap-4 grid-cols-1 lg:grid-cols-3">
            <StatCard
                label="Total Invertido"
                value={formatCurrency(analytics.totalInvestment)}
                icon={<DollarSign />}
                tone="success"
                hint="Suma de todas las campañas"
                footer={
                    <>
                        <MetricRow label="Campañas" value={formatNumber(analytics.totalCampaigns)} />
                        <MetricRow label="Pisos de venta" value={formatNumber(analytics.totalStores)} />
                    </>
                }
            />
            <div className="lg:col-span-2 grid gap-4 grid-cols-1 sm:grid-cols-2">
                <StatCard label="Total Campañas" value={formatNumber(analytics.totalCampaigns)} icon={<Flag />} tone="violet" hint="Campañas registradas" />
                <StatCard label="Activas" value={formatNumber(analytics.activeCampaigns)} icon={<CircleCheck />} tone="success" hint="Campañas vigentes" />
                <StatCard label="Expiradas" value={formatNumber(analytics.expiredCampaigns)} icon={<TriangleAlert />} tone="warning" hint="Requieren renovación" />
                <StatCard label="Inactivas" value={formatNumber(analytics.inactiveCampaigns)} icon={<CircleX />} tone="danger" hint="Campañas pausadas" />
            </div>
        </div>
    );
}
